const recommendTagToastMsg = {
  /**
   *  추천 턔그 리스트 요청하기
   */
  GET_RECOMMEND_TAG_LIST_REQUEST_SUCCESS: '추천 태그 리스트 요청하기 성공',
  GET_RECOMMEND_TAG_LIST_REQUEST_ERROR: '추천 태그 리스트 요청하기 실패',

  /**
   *  추천 턔그 상세 요청하기
   */
  GET_RECOMMEND_TAG_DETAIL_REQUEST_SUCCESS: '추천 태그 상세 요청하기 성공',
  GET_RECOMMEND_TAG_DETAIL_REQUEST_ERROR: '추천 태그 상세 요청하기 실패',

  /**
   *  추천 턔그 복사하기 전 필요한 데이터 요청하기
   */
  PREPARE_COPY_RECOMMEND_TAG_REQUEST_SUCCESS: '추천 태그 복사하기 전 필요한 데이터 요청하기 성공',
  PREPARE_COPY_RECOMMEND_TAG_REQUEST_ERROR: '추천 태그 복사하기 전 필요한 데이터 요청하기 실패',

  /**
   *  추천 턔그 등록하기 전 필요한 데이터 요청하기
   */
  PREPARE_CREATE_RECOMMEND_TAG_REQUEST_SUCCESS: '추천 태그 등록하기 전 필요한 데이터 요청하기 성공',
  PREPARE_CREATE_RECOMMEND_TAG_REQUEST_ERROR: '추천 태그 등록하기 전 필요한 데이터 요청하기 실패',

  /**
   *  추천 턔그에 연결할 아이템 리스트 요청하기
   */
  GET_RECOMMEND_TAG_ITEM_REQUEST_SUCCESS: '추천 태그에 연결할 아이템 리스트 요청하기 성공',
  GET_RECOMMEND_TAG_ITEM_REQUEST_ERROR: '추천 태그에 연결할 아이템 리스트 요청하기 실패',

  /**
   *  추천 턔그 등록/복사하기
   */
  CREATE_RECOMMEND_TAG_REQUEST_SUCCESS: '추천 태그 등록/복사하기 성공',
  CREATE_RECOMMEND_TAG_REQUEST_ERROR: '추천 태그 등록/복사하기 실패',

  /**
   *  전체 턔그 리스트 EXCEL 다운로드
   */
  GET_RECOMMEND_TAG_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '전체 태그 리스트 EXCEL 다운로드 성공',
  GET_RECOMMEND_TAG_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '전체 태그 리스트 EXCEL 다운로드 실패',

  /**
   *  선택된 턔그 리스트 EXCEL 다운로드
   */
  GET_SELECTED_RECOMMEND_TAG_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '선택된 태그 리스트 EXCEL 다운로드 성공',
  GET_SELECTED_RECOMMEND_TAG_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '선택된 태그 리스트 EXCEL 다운로드 실패',

  /**
   *  턔그 리스트 EXCEL 업로드
   */
  SET_RECOMMEND_TAG_ITEM_LIST_EXCEL_UPLOAD_REQUEST_SUCCESS: '태그 리스트 EXCEL 업로드 성공',
  SET_RECOMMEND_TAG_ITEM_LIST_EXCEL_UPLOAD_REQUEST_ERROR: '태그 리스트 EXCEL 업로드 실패',
};

export default recommendTagToastMsg;
